import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminDinners = lazy(() => import("@/pages/admin/AdminDinners"));

export const Route = createFileRoute("/admin/dinners")({
  component: AdminDinners,
});
